module.exports = __webpack_public_path__ + "assets/images/project/banner_image_blueneutral_wphoto.jpg?v=c45a8f54";